module.exports = "<my-area-display my-area=\"$$area.data.myArea\"\n  my-railways=\"$$railway.data.myRailways\"\n  enable-local-search=\"true\"\n  enable-title=\"true\"\n  enable-badges=\"true\"\n  enable-buttons=\"true\"\n  enable-excel=\"true\"\n  enable-links=\"true\"\n  enable-progression=\"true\"\n  enable-back=\"true\">\n</my-area-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/area/templates/details.html
// module id = 1486
// module chunks = 0